/**
 * Sprint 39, story-212. The ONE list of top-level app paths that exist behind login (some of them
 * only for certain roles). A logged-out visitor hitting one of these is sent to the login page
 * with the requested path saved, instead of seeing a 404. Role-gated routes are not mounted when
 * logged out, so they cannot be listed from the <Switch> itself; this list covers them.
 *
 * Matching is segment-aware (react-router `path` array semantics): `/invoices` and `/invoices/9`
 * match, `/invoicesx` does not. `/admin` is deliberately not a prefix: an unknown `/admin/foo`
 * should 404. Keep in sync with the private routes in `App.tsx`.
 */
export const KNOWN_APP_PATH_PREFIXES: string[] = [
  '/organizations',
  '/subscription-plans',
  '/user-admin',
  '/admin-billing',
  '/admin/warehouse',
  '/admin/platform-status',
  '/admin/notification-recipients',
  '/admin/invoices',
  '/admin/field-capture',
  '/settings',
  '/home',
  '/dashboard',
  '/trial-expired',
  '/mapView',
  '/ui',
  '/profile',
  '/assistant',
  '/reports',
  '/billing',
  '/users',
  '/projects',
  '/templates',
  '/schedule',
  '/clients',
  '/crews',
  '/subcontractors',
  '/budgets',
  '/invoices',
  '/documents',
  '/incidents',
  '/warehouse',
  '/geofences',
];

export const isKnownAppPath = (pathname: string): boolean =>
  KNOWN_APP_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
